import { FieldType } from 'src/Common/Filters/interfaces/FiltersView';

export const ROBFilterConfig = [
  {
    fieldId: 'ID',
    fieldName: 'ID',
    fieldType: FieldType.TextField,
    internalName: 'raidid',
    responseFormat: 'number',
  },
  {
    fieldId: 'Title',
    fieldName: 'Title',
    fieldType: FieldType.TextField,
    internalName: 'fields/title',
    responseFormat: 'string',
  },
  {
    fieldId: 'Requestor',
    fieldName: 'Requestor',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/requestorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'RequestedDate',
    fieldName: 'Requested Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/requesteddate',
    responseFormat: 'date',
    isMaxCurrentDate: true,
  },
  {
    fieldId: 'SolutionArea',
    fieldName: 'Solution Area',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'solutionAreas',
    keyName: 'solutionArea',
    internalName: 'raidrelations/msxaccounts/accounts/opportunities/solutionarealist',
    responseFormat: 'array',
    useQuery: `raidrelations/msxaccounts/accounts/any(x: x/opportunities/any(y: y/solutionarealist/any(r: @replacefiltervalues)))`,
  },
  {
    fieldId: 'Segment',
    fieldName: 'Segment(s)',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'rob_Segments',
    keyName: 'displayName',
    internalName: 'fields/segmentslist',
    responseFormat: 'array',
  },
  {
    fieldId: 'Region',
    fieldName: 'Region(s)',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'region',
    keyName: 'RegionName',
    internalName: 'fields/regions',
    responseFormat: 'array',
  },
  {
    fieldId: 'Areas',
    fieldName: 'Areas/SME&C OU',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'areas',
    keyName: 'area',
    internalName: 'fields/areas',
    responseFormat: 'array',
  },
  {
    fieldId: 'SubRegion',
    fieldName: 'Sub-region/SME&C SU',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'subRegion',
    keyName: 'subRegion',
    internalName: 'fields/subregions',
    responseFormat: 'array',
  },
  {
    fieldId: 'MeetingFiscalYear',
    fieldName: 'Meeting Fiscal Year',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'fys',
    keyName: 'fy',
    internalName: 'fields/fy',
    responseFormat: 'string',
  },
  {
    fieldId: 'MeetingQuarter',
    fieldName: 'Meeting Quarter',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'quarters',
    keyName: 'quarter',
    internalName: 'fields/quarter',
    responseFormat: 'string',
  },
  {
    fieldId: 'MeetingMonth',
    fieldName: 'Meeting Month',
    fieldType: FieldType.Dropdown,
    internalName: 'fields/month',
    responseFormat: 'string',
    isCustomField: true,
  },
  {
    fieldId: 'MeetingType',
    fieldName: 'MCAPS Meeting Types',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'meetingTypeOrigins',
    keyName: 'meetingTypeOrigin',
    internalName: 'fields/meetingtypelist',
    responseFormat: 'array',
    isCustomField: true,
  },
  {
    fieldId: 'MeetingSubType',
    fieldName: 'MCAPS Meeting Sub-types',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'meetingSubTypes',
    keyName: 'meetingSubType',
    internalName: 'fields/meetingsubtypelist',
    responseFormat: 'array',
    isCustomField: true,
  },
  {
    fieldId: 'State',
    fieldName: 'State',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'workItemStates',
    keyName: 'Name',
    internalName: 'fields/state',
    responseFormat: 'string',
  },
  {
    fieldId: 'SubState',
    fieldName: 'Sub State',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'subStates',
    keyName: 'subState',
    internalName: 'fields/substate',
    responseFormat: 'string',
  },
  {
    fieldId: 'ActionOwnerGroup',
    fieldName: 'Action Owner Group',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'mcapsROBActionOwnerGrp',
    keyName: 'actionOwnerGroup',
    internalName: 'fields/actionownergroup',
    responseFormat: 'string',
  },
  {
    fieldId: 'ActionOwner',
    fieldName: 'Action Owner',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/assignedto/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'AccountableExec',
    fieldName: 'Accountable Exec',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/accountableexec/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'Contributors',
    fieldName: 'Contributors',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/contributorsinfo/uniquename',
    responseFormat: 'arrayOfObjects',
  },
  {
    fieldId: 'ActionCategory',
    fieldName: 'Action Category',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'robActionCategory',
    keyName: 'displayName',
    internalName: 'fields/actioncategoryfield',
    responseFormat: 'string',
  },
  {
    fieldId: 'RobImpactTypes',
    fieldName: 'Impact Type',
    fieldType: FieldType.CustomDropdown,
    fieldDropdownName: 'Rob_ImpactTypes',
    keyName: 'displayName',
    internalName: 'fields/impacttypelist',
    responseFormat: 'string',
  },
  // {
  //   fieldId: 'RevenueImpact',
  //   fieldName: 'Revenue Impact (USD)',
  //   fieldType: FieldType.TextField,
  //   internalName: 'fields/revenueimpact',
  //   responseFormat: 'number',
  // },
  {
    fieldId: 'Priority',
    fieldName: 'Priority',
    fieldType: FieldType.Dropdown,
    fieldDropdownName: 'raidPriority',
    keyName: 'priorityname',
    internalName: 'fields/actionpriorityfield',
    responseFormat: 'string',
  },
  {
    fieldId: 'DueDate',
    fieldName: 'Due Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/duedate',
    responseFormat: 'date',
  },
  {
    fieldId: 'ClosedDate',
    fieldName: 'Closed Date',
    fieldType: FieldType.DatePicker,
    internalName: 'fields/closeddate',
    responseFormat: 'date',
  },
];
